module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.elementId
    }
  }, [_c('auto-responsive', _vm._b({}, 'auto-responsive', _vm.options, false), _vm._l((_vm.styleList), function(item, index) {
    return _c('div', {
      staticClass: "item",
      style: (_vm.styleList[index]),
      on: {
        "click": _vm.clickItemHandle
      }
    }, [_vm._v(_vm._s(index))])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a778126"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./homepage/waterfall.vue
// module id = 160
// module chunks = 0